var map = {
	"./antiseptics.jpg": "ae09",
	"./beverages-food.jpg": "6dd9",
	"./colors-flavors.jpg": "c5ef",
	"./cooking-food.jpg": "682f",
	"./delivery.jpg": "bfed",
	"./dp1.jpg": "cce8",
	"./dp2.jpg": "a8f3",
	"./dp3.jpg": "9bd2",
	"./food-supplements.jpg": "f7e6",
	"./fresh-fruits.jpg": "5fa4",
	"./fresh-veg.jpg": "f52a",
	"./fruits-veg-food.jpg": "0d89",
	"./order.jpg": "4481",
	"./payment.jpg": "bd55",
	"./soft-drinks.jpg": "68f5",
	"./spices.jpg": "1096",
	"./syrups-powders.jpg": "4d57",
	"./vegetables.jpg": "edf1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "710a";